// A Run of Show activity's Hard Time, edited as parts but stored as the text
// the Run of Show already uses for EPS / proposal rows ("Hard Set 2:00 PM",
// "Hard Out 1:00 AM (next day)"), so the builder and the PDF print it as before.

export const HARD_TIME_TYPES = ['Hard Set', 'Hard Out', 'Deadline', 'Other'];

const empty = () => ({ type: '', label: '', time: '', nextDay: false });

/**
 * Stored text → { type, label, time, nextDay }. Text that is not "<name> <h:mm AM>"
 * (older free text) comes back as Other with the whole text as its label, so
 * saving it unchanged writes the same text.
 */
export function parseHardTime(text) {
  const raw = String(text || '').trim();
  if (!raw) return empty();
  const m = raw.match(/^(.*?)\s*(\d{1,2}:\d{2})\s*([AaPp])\.?\s*[Mm]\.?\s*(\(next day\))?$/);
  if (!m) return { ...empty(), type: 'Other', label: raw };
  const name = m[1].trim();
  const time = `${parseInt(m[2].split(':')[0], 10)}:${m[2].split(':')[1]} ${m[3].toUpperCase()}M`;
  const known = HARD_TIME_TYPES.slice(0, 3).find((t) => t.toLowerCase() === name.toLowerCase());
  return { type: known || 'Other', label: known ? '' : name, time, nextDay: !!m[4] };
}

/** { type, label, time, nextDay } → stored text ('' when no type). */
export function formatHardTime(h) {
  const v = h || {};
  if (!v.type) return '';
  const name = v.type === 'Other' ? String(v.label || '').trim() : v.type;
  return [name, v.time].filter(Boolean).join(' ') + (v.time && v.nextDay ? ' (next day)' : '');
}

/** What stops a Hard Time from being saved. */
export function hardTimeErrors(h) {
  const v = h || {};
  if (!v.type) return [];
  if (v.type === 'Other' && !String(v.label || '').trim()) return ['Name the hard time (Other).'];
  if (v.type !== 'Other' && !v.time) return [`Choose the ${v.type} time.`];
  return [];
}
